module.exports = __webpack_public_path__ + "img/vertical_7_2_2.c3289e26.png";